import React from 'react';
import PropTypes from 'prop-types';
import './index.module.css';

const Button = ({
  variant = 'primary',
  fullWidth = false,
  loading = false,
  disabled = false,
  noPadding = false,
  iconRight = false,
  type = 'button',
  onClick,
  children,
  className = '',
  form,
  ...rest
}) => {
  const getVariantClass = () => {
    switch (variant) {
      case 'secondary':
        return 'button--secondary';
      case 'secondary-grass':
        return 'button--secondary button--secondary-grass';
      case 'tertiary':
        return 'button--tertiary';
      case 'tertiary-grass':
        return 'button--tertiary button--tertiary-grass';
      case 'grass':
        return 'button--grass';
      default:
        return '';
    }
  };

  const buttonClasses = [
    'button',
    getVariantClass(),
    fullWidth && 'button--full-width',
    loading && 'button--loading',
    disabled && 'button--disabled',
    noPadding && 'button--no-padding',
    iconRight && 'button--icon-right',
    className
  ].filter(Boolean).join(' ');

  return (
    <button
      type={type}
      className={buttonClasses}
      onClick={onClick}
      disabled={disabled || loading}
      form={form}
      {...rest}
    >
      <span className="button__text">{children}</span>
    </button>
  );
};

Button.propTypes = {
  variant: PropTypes.oneOf(['primary', 'secondary', 'secondary-grass', 'tertiary', 'tertiary-grass', 'grass']),
  fullWidth: PropTypes.bool,
  loading: PropTypes.bool,
  disabled: PropTypes.bool,
  noPadding: PropTypes.bool,
  iconRight: PropTypes.bool,
  type: PropTypes.oneOf(['button', 'submit', 'reset']),
  onClick: PropTypes.func,
  children: PropTypes.node.isRequired,
  className: PropTypes.string,
  form: PropTypes.string
};

export default Button;
